import { withJsonFormsControlProps } from "@jsonforms/react";
import { Dropdown } from "pepsico-ds";
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import "./StringSelect.scss";

const StringSelectComponent = ({
  handleChange,
  label,
  data,
  path,
  schema,
  uischema,
  required,
  enabled,
}) => {
  const dropdownRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const updateValue = (val) => {
    if (schema.type === "array") {
      handleChange(
        path,
        val?.map((item) => item.id)
      );
    } else {
      const newVal = schema.type === "number" ? val?.[0]?.id : val?.[0]?.id || "";
      handleChange(path, newVal);
    }
  };

  const labelMapping = uischema.options?.labelMapping;
  const childList =
    schema.enum?.map((item) => ({
      id: item,
      displayText: labelMapping?.[item] || item,
    })) || [];

  const formatData = (data) => {
    if (schema.type === "array") {
      return data?.map((item) => ({
        id: item,
        displayText: labelMapping?.[item] || item,
      }));
    }

    if (data != null) {
      return [
        {
          id: data,
          displayText: labelMapping?.[data] ?? data,
        },
      ];
    }

    return [];
  };

  useEffect(() => {
    if (dropdownRef.current && uischema?.labelTooltip) {
      const infoIcon = dropdownRef.current.querySelector(".label-element .icon");
      if (infoIcon) {
        // Remove the default title attribute to prevent native tooltip
        infoIcon.removeAttribute("title");
        infoIcon.style.cursor = "pointer";

        // Add hover event listeners
        const handleMouseEnter = () => setShowTooltip(true);
        const handleMouseLeave = () => setShowTooltip(false);

        infoIcon.addEventListener("mouseenter", handleMouseEnter);
        infoIcon.addEventListener("mouseleave", handleMouseLeave);

        return () => {
          infoIcon.removeEventListener("mouseenter", handleMouseEnter);
          infoIcon.removeEventListener("mouseleave", handleMouseLeave);
        };
      }
    }
  }, [uischema?.labelTooltip]);

  return (
    <div className="string-select-component" ref={dropdownRef}>
      <Dropdown
        isRequired={required}
        childList={childList}
        dropdownHeader={schema.header}
        style={{ minWidth: "0px" }}
        className="zIndexToDropDown"
        label={label}
        info={uischema?.labelTooltip || ""}
        showLabelIcon={uischema?.labelTooltip ? true : false}
        helperText={uischema?.helperText}
        selection={uischema.selection || "single"}
        selectedValue={formatData(data)}
        setSelectedValue={updateValue}
        size={uischema.size || "medium"}
        placeholder={uischema.placeholder || ""}
        disabled={
          enabled === false ||
          uischema?.readOnly ||
          uischema?.readonly ||
          uischema?.disabled ||
          uischema?.options?.readonly ||
          uischema?.options?.disabled
        }
      />
      {showTooltip && uischema?.labelTooltip && (
        <div className="custom-tooltip">{uischema.labelTooltip}</div>
      )}
    </div>
  );
};
StringSelectComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.any,
  path: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired,
  uischema: PropTypes.shape({
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    options: PropTypes.shape({
      readonly: PropTypes.bool,
      disabled: PropTypes.bool,
      labelMapping: PropTypes.object,
    }),
    selection: PropTypes.string,
    size: PropTypes.string,
    placeholder: PropTypes.string,
    helperText: PropTypes.string,
    labelTooltip: PropTypes.string,
    default: PropTypes.any,
  }).isRequired,
  required: PropTypes.bool,
  enabled: PropTypes.bool,
};

export const StringSelectControl = withJsonFormsControlProps(StringSelectComponent);
